import React from "react";
import { Users, ShieldCheck, Clock, MapPin } from "lucide-react";
import "../style/statsSection.css";

const StatsSection = () => {
  return (
    <section className="trust-stats-section">
      <div className="trust-stats-inner">

        <p className="trust-text">
          Trusted by <span className="highlight">homeowners</span>,{" "}
          <span className="highlight">builders and businesses</span> across
          the region.
        </p>

        <div className="stats-grid">
          <div className="stat-item">
            <Users className="stat-svg" />
            <h4>5000+</h4>
            <span>Happy Customers</span>
          </div>
          <div className="stat-item">
            <ShieldCheck className="stat-svg" />
            <h4>98%</h4>
            <span>Satisfaction Rate</span>
          </div>
          <div className="stat-item">
            <Clock className="stat-svg" />
            <h4>On Time</h4>
            <span>Every Time</span>
          </div>
          <div className="stat-item">
            <MapPin className="stat-svg" />
            <h4>Local & Reliable</h4>
            <span>Proudly Local</span>
          </div>
        </div>

      </div>
    </section>
  );
};

export default StatsSection;